const WEB_SCENE_VERSION_PATTERN = /^[a-f0-9]{32}$/i;

export const isWebSceneVersion = value =>
  WEB_SCENE_VERSION_PATTERN.test(String(value || '').trim());

export const buildWebSceneUrl = ({baseUrl, version, location}) =>
  `${baseUrl}${version}/${location}/index.html`;

/**
 * Remote Config can temporarily point at a partial scene upload. Check only the
 * requested scene before accepting an override; otherwise use the source-pinned
 * release version. The fallback remains deterministic and does not depend on a
 * second network probe.
 */
export const resolveWebSceneUrl = async ({
  baseUrl,
  remoteVersion,
  fallbackVersion,
  location,
  fetchImpl = global.fetch,
}) => {
  const safeFallback = String(fallbackVersion || '').trim();
  const safeRemote = String(remoteVersion || '').trim();
  const fallbackUrl = buildWebSceneUrl({
    baseUrl,
    version: safeFallback,
    location,
  });

  if (
    !isWebSceneVersion(safeRemote) ||
    safeRemote.toLowerCase() === safeFallback.toLowerCase() ||
    typeof fetchImpl !== 'function'
  ) {
    return fallbackUrl;
  }

  const remoteUrl = buildWebSceneUrl({
    baseUrl,
    version: safeRemote,
    location,
  });

  try {
    const response = await fetchImpl(remoteUrl, {
      method: 'HEAD',
      cache: 'no-store',
      credentials: 'same-origin',
    });
    return response?.ok ? remoteUrl : fallbackUrl;
  } catch (_) {
    return fallbackUrl;
  }
};
